import type { Ref } from 'react';
import type { HTMLAttributes } from 'react';
import { Tooltip } from './ButtonControl';
import { cx } from '../lib/cx';

export interface SelectableLabelProps extends HTMLAttributes<HTMLSpanElement> {
  isActive?: boolean;
}

export function SelectableLabel(
  { ref, isActive = false, className, children, ...rest }: SelectableLabelProps & { ref?: Ref<HTMLSpanElement> },
) {
    const interactive = Boolean(rest.onClick);
    const label = (
      <span ref={ref} className={cx('selectable-label', isActive && 'is-active', className)}
        role={interactive ? 'button' : undefined} tabIndex={interactive ? 0 : undefined} {...rest}
        onKeyDown={(event) => {
          rest.onKeyDown?.(event);
          if (!event.defaultPrevented && interactive && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            event.currentTarget.click();
          }
        }}>
        {children}
      </span>
    );
    return interactive ? <Tooltip>{label}</Tooltip> : label;
  }
